<template>
  <slot name="insertFooter"></slot>
  <MButton v-if="showCancelBtn" v-bind="cancelButtonProps" @click="emit('cancel', $event)">
    {{ t(cancelText) }}
  </MButton>
  <slot name="centerFooter"></slot>
  <MButton
    v-if="showOkBtn"
    :loading="confirmLoading"
    type="primary"
    v-bind="okButtonProps"
    @click="emit('ok', $event)"
  >
    {{ t(okText) }}
  </MButton>
  <slot name="appendFooter"></slot>
</template>

<script lang="ts" setup>
  import { t } from '@mts/hooks/web/useI18n';
  import { basicProps } from '../props';

  defineOptions({ name: 'BasicModalFooter', inheritAttrs: false });

  defineProps(basicProps);

  const emit = defineEmits(['ok', 'cancel']);
</script>
